import { HttpClient, HttpParams, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TcmFileBlobResponse } from "../extensions/tcm-file-blob-response-extensions";

@Injectable({providedIn: 'root'})
export class TcmHttpClient {

    constructor(private http: HttpClient) {}

    getFileAsyncWithPost(url: string, data: any) : Promise<TcmFileBlobResponse> {
        
        const promise = new Promise<TcmFileBlobResponse>((resolve, reject) => {

            const httpParams = new HttpParams();
            const httpRequest = new HttpRequest("POST", 'api/' + url, data, { responseType: 'blob', params: httpParams });
            const requestSubscription = this.http.request<any>(httpRequest)
            requestSubscription.subscribe(event => {
                 if (event instanceof HttpResponse) {
        
                    const response = event;
        
                    const contentDispositionHeader = response.headers.get('Content-Disposition');
        
                    const parts = contentDispositionHeader.split(';');
        
                    const fileName = parts[1].split('=')[1];
        
                    const fileBlobResponse = new TcmFileBlobResponse(fileName, response.body);
                    //saveAs(response.body, fileName.replace(new RegExp('"', 'g'), ''))
                    resolve(fileBlobResponse);
                }
            });
      
          });
      
          return promise;
    }
}